import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {alertActions, contracterActions} from '../../../store/actions'
import PopupAddFiles from "../PopupAddFiles";
import history from "../../../route/history";
import moment from "moment";
import {commons} from "../../../hook/common";

/**
 * 구매확인서 3단계 / 근거서류 목록
 */
const CertificateStep03 = props => {
  const [ docid, setDocid] = useState();
  const [ fileList, setFileList] = useState(props.stepData);
  const [ showAddFiles, setShowAddFiles] = useState(false);

  const fileType = [
    { title : '수출신고필증', value: '811'},
    { title : '외화표시 수출계약서', value: '465'},
  ]

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split("=")[1];
    let key =  props.search?.split("=")[0];

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id));

      //이전 페이지 정보가 없을 경우 첫 화면으로 이동
      if (!data || data?.step2?.length <= 0) {
        history.replace('/service/apply/1?id='+ id);
        return;
      }
      setDocid(id);
      setFileList(data.step3);

    } else {
      history.replace('/service/apply/1');
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {

    if (props.isCalled === true) {
      setFileList(props.stepData);
    }
    props.setCalled(false);

  }, [props?.isCalled])

  return (
      <React.Fragment>
        {showAddFiles && <PopupAddFiles
            onClose={() => setShowAddFiles(false)}
            docid={docid}
        />}

        <div className="step-title m-t-20 m-b-10">
            근거서류 목록<span className="required">*</span>
            <span>(외화획득임을 증명하는 서류)</span>
            <p className="des">구매물품 목록 작성시 수출신고내역 불러오기 기능을 사용하면 수출신고필증 정보가 자동을 채워집니다.</p>
        </div>

        <div className="title-btn m-t-20">
            <div className="dis-flex ">
                <span className="totalPage w-50">총 {fileList?.length}건</span>
                <div className="flex-r w-50">
                    <button className="btn btn-white" onClick={() => setShowAddFiles(true)}>근거서류 등록/수정</button>
                </div>
            </div>
        </div>
        <div className="table">
          <div className="row header border">
            <div className="cell w-10">근거서류명 및 번호</div>
            <div className="cell ">HS부호</div>
            <div className="cell w-10">품명</div>
            <div className="cell w-10">규격</div>
            <div className="cell w-10">금액</div>
            <div className="cell w-7">선적기일</div>
          </div>
          {
            fileList?.length > 0 ?
                fileList?.map((item, index) => {
                  return <div className="row" key={index}>
                    <div className="cell" data-title={"근거서류명 및 번호"}>
                      {fileType.find((file) => {
                        return file.value === item.fileCd
                      })?.title}
                      <br/>[{item.fileNo}]
                    </div>
                    <div className="cell" data-title={"HS부호"}>{item.hsCd}</div>
                    <div className="cell" data-title={"품명"}>{item.itemnm}</div>
                    <div className="cell" data-title={"규격"}>{item.itemdeftxt}</div>
                    <div className="cell" data-title={"금액"}>{item.totamtcur} {commons.addComma(item.amt)}</div>
                    <div className="cell" data-title={"선적기일"}>{moment(item.stngYmd).format('Y-M-D')}</div>
                  </div>
                })
                : <div className="row noData"><div className="cell" >등록된 자료가 없습니다.</div></div>
          }
        </div>
        <div className="detail-btn">
            <button className="btn btn-white float-l" onClick={props.doDelete}>삭제</button>
            <button className="btn btn-blue" onClick={() => history.goBack()}>이 전</button>
            <button className="btn btn-blue" onClick={props.goStepNext}>다 음</button>
        </div>

      </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    stepData : state.contracter?.data?.step3,
    totalData: state.contracter.data,
    isCalled: state.contracter.isCalled,
  }
}

const actionCreators = {
  setCalled: contracterActions.setCalled,
  alert: contracterActions.alert,
  error: alertActions.error,
}

export default connect(
    mapStateToProps,
    actionCreators
)(CertificateStep03)
